import { useEffect, useState } from "react";

/**
 * Which indicator the settings modal (TV-17) is open for; ✏️ in the legend,
 * the pane headers and the Current tab of the indicators menu open it.
 * Save goes to engine.updateIndicator (useIndicators saves the list, so the
 * changes survive F5), Remove removes the indicator; both close the modal.
 * The modal closes by itself when its indicator is gone.
 *
 * @param {object|null} engine - ChartEngine
 * @param {object} indicatorsApi - useIndicators
 * @returns {{
 *   indicator: object|null, palette: string[], open: (key: string) => void, close: () => void,
 *   save: (changes: object) => void, remove: () => void,
 * }} indicator: the engine.getIndicators() item being edited, null while the modal is closed
 */
const useIndicatorSettingsModal = (engine, indicatorsApi) => {
  const { indicators, update, remove: removeIndicator } = indicatorsApi;
  const [editingKey, setEditingKey] = useState(null);
  const indicator = indicators.find(({ key }) => key === editingKey) || null;

  const open = (key) => setEditingKey(key);

  const close = () => setEditingKey(null);

  useEffect(() => {
    if (editingKey && !indicator) setEditingKey(null);
  }, [editingKey, indicator]);

  const save = (changes) => {
    update(editingKey, changes);
    close();
  };

  const remove = () => {
    removeIndicator(editingKey);
    close();
  };

  return {
    indicator,
    palette: indicator && engine ? engine.getLinePalette() : [],
    open,
    close,
    save,
    remove,
  };
};

export default useIndicatorSettingsModal;
